import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { G2FormsModalComponent } from './g2-forms-modal.component';
import {
  ButtonModule,
  BannerModule
} from '@xref/xref-lib';

@NgModule({
  declarations: [G2FormsModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    BannerModule
  ],
  exports: [G2FormsModalComponent]
})
export class G2FormsModalModule { }